import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useFetch } from '@/hooks/useFetch';
import type { ErrorResponse } from '@/types/apiTypes';
import type {
  GetImportantDatesResponse,
  CreateImportantDatePayload,
} from '@/types/clientDetailsApiTypes';
import { IMPORTANT_DATES_BY_CLIENT_QUERY_KEY } from '../useGetImportantDatesByClientQuery';

interface CreateImportantDateResponse {
  data: GetImportantDatesResponse['data'][number];
}

export function useCreateImportantDateMutation() {
  const queryClient = useQueryClient();
  const { doFetch: createImportantDate } = useFetch<
    CreateImportantDatePayload,
    CreateImportantDateResponse
  >();

  return useMutation<
    CreateImportantDateResponse,
    ErrorResponse<unknown>,
    CreateImportantDatePayload
  >({
    mutationFn: (payload: CreateImportantDatePayload) =>
      createImportantDate('/api/important-dates', {
        method: 'POST',
        body: payload,
      }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [IMPORTANT_DATES_BY_CLIENT_QUERY_KEY, variables.client_id],
        refetchType: 'all',
      });
    },
  });
}
